import * as React from 'react';

import { Alert, Grid, Spacer, Typography } from '@emburse/ui-core';

import { ConfirmModal } from '@ReactComponents/ConfirmModal';

import { ICompanyModel, IUserModel } from '@Shared/models';

interface ISignUpConfirmationModalProps {
  closeModal(): void;
  onConfirm?(): Promise<void>;
  user?: IUserModel;
  company?: ICompanyModel;
}

export const SignUpConfirmationModal: React.FC<ISignUpConfirmationModalProps> = ({ closeModal, user, company, onConfirm }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      closeModal();
    } catch (e: any) {
      try {
        const parsed = JSON.parse(e?.message);
        setError(parsed.error || e?.message);
      } catch {
        setError(e?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      headerText="Continue to Emburse Cards Application?"
      cancelText="Cancel"
      confirmText="Next"
      closeModal={closeModal}
      onConfirm={handleConfirm}
      showClose={true}
      isLoading={loading}
    >
      <Spacer size={10} />
      {error && (
        <>
          <Alert severity="error">{error}</Alert>
          <Spacer size={16} />
        </>
      )}
      <div>Upon clicking continue below you won't be able to come back to edit this personal information and company information. </div>
      <Spacer size={25} />
      <Typography variant="h6">Company Information</Typography>
      <Spacer size={10} />
      <Grid>
        <Typography>
          <b>Legally Registered Business Name:</b> {company.name}
        </Typography>
        <Typography>
          <b>Street Address:</b> {company.street_address}
        </Typography>
        <Typography>
          <b>State:</b> {company.address_state}
        </Typography>
        <Typography>
          <b>Zip:</b> {company.postal_code}
        </Typography>
        <Typography>
          <b>Website:</b> {company.website || 'N/A'}
        </Typography>
        <Typography>
          <b>Phone #:</b> {company.phone_number}
        </Typography>
      </Grid>
      <Spacer size={25} />
      <Typography variant="h6">Personal Information</Typography>
      <Spacer size={10} />
      <Grid>
        <Typography>
          <b>First Name:</b> {user.first_name}
        </Typography>
        <Typography>
          <b>Last Name:</b> {user.last_name}
        </Typography>
        <Typography>
          <b>Home Address:</b> {user.street_address}
        </Typography>
        <Typography>
          <b>State / Territory:</b> {user.address_state}
        </Typography>
        <Typography>
          <b>Zip:</b> {user.postal_code}
        </Typography>
        <Typography>
          <b>Country:</b> {user.address_country}
        </Typography>
        <Typography>
          <b>Birthday:</b> {user.dob_month}/{user.dob_day}/{user.dob_year}
        </Typography>
        <Typography>
          <b>Phone Number:</b> {user?.phone_number}
        </Typography>
      </Grid>
      <Spacer size={25} />
    </ConfirmModal>
  );
};
